import { createReducer } from '@reduxjs/toolkit';
import {
	generateOtpAction,
	generateOtpResultSuccessAction,
	IGenerateOtpRequest,
	IMatchOtpRequest,
	IGenerateOtpResponse,
	IMatchOtpResponse,
	matchOtpRequestAction,
	matchOtpResultSuccessAction,
	toggleOtpModalAction,
	INewPasswordRequest,
	INewPasswordSuccess,
	newPasswordRequestAction,
	newPasswordSuccessAction,
	generateOtpResultFailedAction,
	matchOtpResultFailedAction,
	newPasswordFailedAction,
	removeForgotPasswordErrorAction,
} from '../actions/ForgotPasswordAction';

export interface IForgotPasswordState {
	loading: boolean;
	payload: IGenerateOtpRequest;
	response: IGenerateOtpResponse;
	error: string;
}

export interface IGenerateOtpState {
	loading: boolean;
	payload: IGenerateOtpRequest;
	response: IGenerateOtpResponse;
	error: string;
}

export interface IMatchOtpState {
	loading: boolean;
	payload: IMatchOtpRequest;
	response: IMatchOtpResponse;
	error: string;
}

export interface INewPasswordState {
	loading: boolean;
	payload: INewPasswordRequest;
	response: INewPasswordSuccess;
	error: string;
}

interface ForgotPasswordState {
	generateOtpState: IGenerateOtpState;
	matchOtpState: IMatchOtpState;
	newPasswordState: INewPasswordState;
	showOtpModal: boolean;
}

const forgotPasswordState: ForgotPasswordState = {
	generateOtpState: {
		loading: false,
		payload: {
			recipient: '',
			purpose: 1,
			vendor: 1,
		},
		response: {
			transactionId: 0,
			expiredAt: '',
			createdAt: '',
			otpCode: '',
		},
		error: '',
	},
	showOtpModal: false,
	matchOtpState: {
		loading: false,
		payload: {
			transactionId: 0,
			otpCode: '',
			recipient: '',
			type: 'lender_institutional',
		},
		response: {
			isMatch: false,
			purpose_data: {
				forgot_pasword_token: '',
			},
		},
		error: '',
	},
	newPasswordState: {
		loading: false,
		payload: {
			phoneNumber: '',
			newPassword: '',
			confirmPassword: '',
			type: 'lender_institutional',
			forgotPasswordToken: '',
		},
		response: {
			message: '',
		},
		error: '',
	},
};

const forgotPasswordReducer = createReducer(forgotPasswordState, (builder) => {
	builder
		.addCase(generateOtpAction, (state, action) => ({
			...state,
			generateOtpState: {
				loading: true,
				payload: action.payload,
				response: state.generateOtpState.response,
				error: '',
			},
		}))
		.addCase(generateOtpResultSuccessAction, (state, action) => ({
			...state,
			generateOtpState: {
				loading: false,
				payload: state.generateOtpState.payload,
				response: action.payload,
				error: '',
			},
			showOtpModal: true,
		}))
		.addCase(generateOtpResultFailedAction, (state, action) => ({
			...state,
			generateOtpState: {
				loading: false,
				payload: state.generateOtpState.payload,
				response: state.generateOtpState.response,
				error: action.payload,
			},
		}))
		.addCase(matchOtpRequestAction, (state, action) => ({
			...state,
			matchOtpState: {
				loading: true,
				payload: {
					transactionId: action.payload.transactionId,
					otpCode: action.payload.otpCode,
					recipient: action.payload.recipient,
					type: action.payload.type,
				},
				response: state.matchOtpState.response,
				error: '',
			},
		}))
		.addCase(matchOtpResultSuccessAction, (state, action) => ({
			...state,
			matchOtpState: {
				loading: false,
				payload: state.matchOtpState.payload,
				response: action.payload,
				error: '',
			},
		}))
		.addCase(matchOtpResultFailedAction, (state, action) => ({
			...state,
			matchOtpState: {
				loading: false,
				payload: state.matchOtpState.payload,
				response: state.matchOtpState.response,
				error: action.payload,
			},
		}))
		.addCase(newPasswordRequestAction, (state, action) => ({
			...state,
			newPasswordState: {
				loading: true,
				payload: action.payload,
				response: state.newPasswordState.response,
				error: '',
			},
		}))
		.addCase(newPasswordSuccessAction, (state) => ({
			...state,
			newPasswordState: {
				loading: false,
				payload: state.newPasswordState.payload,
				response: {
					message: 'success',
				},
				error: '',
			},
		}))
		.addCase(newPasswordFailedAction, (state, action) => ({
			...state,
			newPasswordState: {
				loading: false,
				payload: state.newPasswordState.payload,
				response: state.newPasswordState.response,
				error: action.payload,
			},
		}))
		.addCase(removeForgotPasswordErrorAction, (state, action) => ({
			...state,
			newPasswordState: {
				loading: true,
				payload: state.newPasswordState.payload,
				response: state.newPasswordState.response,
				error: action.payload,
			},
			generateOtpState: {
				loading: false,
				payload: state.generateOtpState.payload,
				response: state.generateOtpState.response,
				error: action.payload,
			},
			matchOtpState: {
				loading: false,
				payload: state.matchOtpState.payload,
				response: state.matchOtpState.response,
				error: action.payload,
			},
		}))
		.addCase(toggleOtpModalAction, (state, action) => ({
			...state,
			showOtpModal: action.payload,
		}))
		.addDefaultCase((state) => state);
});

export default forgotPasswordReducer;
